import { gql } from '@apollo/client';

export const CREATE_SURFACE_WATER_MONITOR = gql`
    mutation CreateSurfaceWaterMonitor($input: CreateSurfaceWaterMonitor!) {
        facility {
            process {
                createSurfaceWaterMonitor(input: $input) {
                    id
                }
            }
        }
    }
`;
